<template>
<div class="chapter">
<div class="inner_page">
<div id="toc" style="font-size:12pt"><h1 id="toc-title">أفكار عشوائية</h1><ol class="toc">
<li id="toc-li-2"><a href="#/text/ch002#أنفال-السعيد"><span dir="rtl">أنفال السعيد</span></a></li><li id="toc-li-3"><span href="#/text/ch003#الإهداء" title="Link target outside of Sample"><span dir="rtl">الإهداء</span></span></li><li id="toc-li-4"><span href="#/text/ch004#حقوق-النشر" title="Link target outside of Sample"><span dir="rtl">حقوق النشر</span>©</span></li><li id="toc-li-5"><span href="#/text/ch005#شكر-وتقدير" title="Link target outside of Sample"><span dir="rtl">شكر وتقدير</span></span></li><li id="toc-li-6"><span href="#/text/ch006#محتوى-الكتاب" title="Link target outside of Sample"><span dir="rtl">محتوى الكتاب</span></span></li><li id="toc-li-7"><span href="#/text/ch007#المقدمة" title="Link target outside of Sample"><span dir="rtl">المقدِّمة</span></span></li><li id="toc-li-8"><span href="#/text/ch008#الفصل-الأول" title="Link target outside of Sample"><span dir="rtl">الفصل الأول</span></span></li><li id="toc-li-9"><span href="#/text/ch009#الفصل-الثاني" title="Link target outside of Sample"><span dir="rtl">الفصل الثاني</span></span></li><li id="toc-li-10"><span href="#/text/ch010#الفصل-الثالث" title="Link target outside of Sample"><span dir="rtl">الفصل الثالث</span></span></li><li id="toc-li-11"><span href="#/text/ch011#الخاتمة" title="Link target outside of Sample"><span dir="rtl">الخاتمة</span></span></li></ol></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?f2c525e0